<template>
	<div class="list-resources">
		<div class="list-resources__heading">
		</div>

		<table-list
			:items="resources"
			:loading="loading"
		>
			<template slot="header">
				<span
					:class="`resources-header-item resources-header-item--${key}`"
					:key="key"
					v-for="(col, key) in columns"
				>
					{{ col }}
				</span>
			</template>

			<template slot="item" slot-scope="{ item }">
				<router-link
					:class="`resources-item resources-item--${key}`"
					:key="`item_${key}`"
					:to="{ name: 'resource', params: { resourceId: item.resourceId } }"
					v-for="(col, key) in columns"
					v-html="transform(key, get(item, key))"
				>
				</router-link>
			</template>
		</table-list>
	</div>
</template>

<script>
import { format, parseISO, formatDistanceToNowStrict } from 'date-fns'
import { get } from 'lodash'
import { ResourceAccess, ResourceStatus, ResourceType } from '@/lib/enums'

import TableList from '@/components/TableList'
import { ResourceCategory } from '../lib/enums';

export default {
	name: 'ListResources',
	components: {
		TableList,
	},
	props: {
		resources: {
			type: Array,
			default: () => ([]),
		},
		loading: Boolean,
	},
	data: () => ({
		columns: {
			name: 'Name',
			url: 'Website',
			type: 'Type',
			access: 'Access',
			category: 'Category',
			dateCreated: 'Created',
			status: 'Status',
		},
	}),
	methods: {
		transform(key, value) {
			switch(key) {
				case 'dateCreated':
					try {
						const dt = parseISO(value)
						value = `<span title="${format(dt, 'Pp')}">${formatDistanceToNowStrict(dt, { addSuffix: true})}</span>`
					} catch (error) {
						console.warn(error)
					}
					return value
				case 'type':
					return ResourceType[value]
				case 'status':
					return ResourceStatus[value]
				case 'access':
					return ResourceAccess[value]
				case 'category':
					return ResourceCategory[value]
				case 'url':
					return value?.length > 100 ? value.substring(0, 100) + '...' : value
					// return `<a href="${value}" target="_blank" rel="noreferrer" title="${value}">Link <ion-icon name="open-outline"></ion-icon></a>`
				default:
					break
			}

			return value
		},
		get,
	},
}
</script>

<style scoped lang="scss">
.list-resources {
	&__heading {
		@include modules.gutter('padding-left');
		@include modules.gutter('padding-right');
	}

	::v-deep .table-list {
		&__item,
		&__header {
			border-bottom: 1px solid modules.color_('background', 'medium');
			display: grid;
			grid-template-columns: 12rem 28rem repeat(4, 1fr) minmax(6rem, auto);

			@include modules.media-query('phone') {
				grid-template-columns: 1fr 1fr;
			}
		}
	}

	.resources-header-item {
		@include modules.fontSize(14px);
		font-weight: 600;
		padding: 1em 1.5em;

		@include modules.media-query('phone') {
			padding: 0.5em 1em;
		}
	}

	.resources-item {
		color: modules.color_('text', 'dark');
		font-weight: 500;
		padding: 1.5em;
		text-decoration: none;

		@include modules.media-query('phone') {
			@include modules.fontSize(15px);
			padding: 0.5em 1em;
		}
	}
}
</style>
